import React, { useState} from 'react';
import * as style from "./past-gallery.module.css"
const PastGallery = ({data}) => {
  const slideCount = Math.ceil(data.googleSheet.Sheet1.length / 9);
  const getIterableSlideCount = () => {
    var val = []
    for(var i = 0; i < slideCount; i++)
    {
      val.push(i)
    }
    return val
  }
  const slideCountIterable = getIterableSlideCount()
  const [slideIndex, setSlideIndex] = useState(0)
  const [selected, setSelected] = useState(-1)
  const columns = () => {
    var columns = []
    var column = []
    data.googleSheet.Sheet1.map(({mainImage}, index) => {
      column.push(mainImage)
      if((index + 1) % 3 === 0){
        columns.push(column)
        column = []
      }
    })
    if(column.length > 0)
    {
      for(var i = column.length; i < 3; i++)
      {
        column.push("https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Fully_transparent_placeholder.svg/900px-Fully_transparent_placeholder.svg.png")
      }
      columns.push(column)
    }
    for(var i = columns.length % 3; i < 3 && i > 0; i++)
    {
      var newCol = []
      for(var j = 0; j < 3; j++)
      {
        newCol.push("https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Fully_transparent_placeholder.svg/900px-Fully_transparent_placeholder.svg.png")
      }
      columns.push(newCol)
    }
    return columns
  }
  const mainImages = columns()

  return (
    <div className = {style.container}>
      <div className = {style.carousel}>
        {
          mainImages.map((column, index) => (
            (Math.floor(index / 3) === slideIndex) && <div key = {index} className = {style.carouselColumn}>
              {column.map((url, i) => (
                <div className = {style.carouselImgBay}>
                  {url === "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Fully_transparent_placeholder.svg/900px-Fully_transparent_placeholder.svg.png" ? 
                  <img key = {url} src = {url} className = {style.carouselFiller}/> : 
                  <img key = {url} src = {url} className = {style.carouselImg} onClick = 
                  {() => {selected === ((index * 3) + i) ? setSelected(-1) : setSelected(((index * 3) + i))}}/>}
                </div>
              ))}
            </div>
          ))
        }
      </div>
      <div className = {style.carouselNav}>
      {slideCountIterable.map(index => (
            <span className = {slideIndex === index ? style.carouselDotSelected: style.carouselDot} onClick = {() => setSlideIndex(index)}></span>
          ))}
      </div>
      <div>
        {
          data.googleSheet.Sheet1.map(({dm, text, threeSixty, exhibition}, index) => (
            (selected === index) && <div key = {index}>
                {dm && dm.split(",").map(url => (
                  {url} && <img src = {url}/>
                ))}
                {exhibition && exhibition.split(",").map(url => (
                  {url} && <img src = {url}/>
                ))}
                {threeSixty && threeSixty.split(",").map(url => (
                  {url} && <img src = {url}/>
                ))}
                {{text} && <p className = {style.exhibitionText}>{text}</p>}
            </div>
          ))
        }
      </div>
    </div>
  )
}

export default PastGallery
